module.exports = __webpack_public_path__ + "media/src/img/payment/optima24-e61c858d172d10b01fa2d41d8df7711b.svg";